'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDances = undefined;

var _getDances2 = require('./getDances');

var _getDances3 = _interopRequireDefault(_getDances2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getDances = _getDances3.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/setMusic/index.js
// module id = 241
// module chunks = 0